import type { EstimationUnit } from '@/api/schema/data-contracts';
import { estimationUnitMessageDefinitions } from '@/context/localization/enums/messages';
import { useMessages } from '@/hooks/messages';

interface EstimationUnitNameProps {
  estimationUnit: EstimationUnit;
}

export const EstimationUnitName: FC<EstimationUnitNameProps> = ({ estimationUnit }) => {
  const messages = useMessages(estimationUnitMessageDefinitions);
  return messages[estimationUnit]();
};
